import React from "react";
import { RightFrameContentSubmissionComponent } from "./RightFrameContentSubmission.component";

interface OwnProps {
	contentNodeId: string;
	setIsModuleExpiredAndFailed: (v: boolean) => void;
	scrollRef?: React.RefObject<HTMLDivElement>;
	scrollOnReady?: boolean;
}
export const RightFrameContainer = ({
	contentNodeId,
	setIsModuleExpiredAndFailed,
	scrollRef,
	scrollOnReady,
}: OwnProps) => {
	return (
		<RightFrameContentSubmissionComponent
			setIsModuleExpiredAndFailed={setIsModuleExpiredAndFailed}
			contentNodeId={contentNodeId}
			scrollRef={scrollRef}
			scrollOnReady={scrollOnReady}
		/>
	);
};
